const messages = {
  crud: {
    new: "Registro creado correctamente",
    update: "Registro actualizado correctamente",
    delete: "Registro eliminado correctamente",
    changeStatus: "Estado cambiado correctamente",
    fail: "Ha ocurrido un error al momento de intentar grabar los datos",
  },
  actions: {
    print: "Impresión realizada correctamente",
    fail: "Ha ocurrido un error al momento de realizar la acción",
  },
  dataFetch: {
    fail: "Ha ocurrido un error al momento de cargar los datos",
  },
  labels: {
    actions: "Acciones",
    save: "Guardar",
    cancel: "Cancelar",
  },
  titles: {
    create: "Crear",
    update: "Actualizar",
  },
  statuses: {
    active: "Activo",
    inactive: "Inactivo",
  },
  errors: {
    submitting: "Ocurrió un error al enviar la información",
    invalidFormat: "Solicitud inválida",
    removingRecord: "Ha ocurrido un error al remover el registro",
    requestError: "Ocurrió un error al realizar la solicitud.",
    fetchingSources: "Ocurrió un error al obtener información del formulario",
  },
  dialogs: {
    confirm: {
      title: "Confirmar acción",
      message: "¿Está seguro de realizar esta acción?",
    },
  },
};

export default messages;
